// extracted by mini-css-extract-plugin
export default {"FinalSum":"sxVIAn4E","speaker":"PFoach4_","speakerImg":"xqlToKK7","box":"mHo9OMaL","description":"j5B0iQdG","icon":"FRxFVswh","descriptionText":"V56bIDJJ","text":"vStDVdQr","sum":"gktxXlx6","forward":"CTbJG5P_","congragTextBox":"YGD5oZQ8","title":"EEH_ogJu"};
    if(module.hot) {
      // 1734636562370
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  